import { validateAndGetHostOrigin } from "shared/src/framework/network/api-client";

let _mediaHost: string = process.env.MEDIA_HOST || "";
let _s3MediaHost: string = process.env.REACT_APP_S3_MEDIA_HOST || "";
export const setMediaHost = (_host?: string, _s3Host?: string) => {
    _mediaHost = _host ? validateAndGetHostOrigin(_host) : "";
    _s3MediaHost = _s3Host ? validateAndGetHostOrigin(_s3Host) : "";
};
export const getMediaHost = () => _mediaHost;

export const getMediaPath = (src: string) => {
    if (src.startsWith("http") || src.startsWith("file") || src.startsWith("data:image"))
        return src;
    let newSrc = src;
    if (!src.startsWith("/")) {
        newSrc = "/" + src;
    }
    return (_mediaHost || "") + newSrc;
};

export const getMediaBase64 = (src: string) => {
    const url = getMediaPath(src).replace(_mediaHost, _s3MediaHost);
    if (src.startsWith("data:image")) return src;
    const outputFormat = "image/png";
    return new Promise<string>((resolve, reject) => {
        const TempImage = window.Image;
        const img = new TempImage();
        img.crossOrigin = "Anonymous";
        img.setAttribute("crossorigin", "anonymous");
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            if (!!ctx) {
                let dataURL;
                canvas.height = img.naturalHeight;
                canvas.width = img.naturalWidth;
                ctx.drawImage(img, 0, 0);
                dataURL = canvas.toDataURL(outputFormat);
                resolve(dataURL);
            }
        };
        img.src = url;
    });
};
